export default __webpack_public_path__ + "static/media/04C.010.16864d84.png";